import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0f12beec&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=0f12beec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12beec",
  null
  
)

export default component.exports